import React from 'react';
import classnames from 'classnames';

import Input from '@components/Input';

import { IDisplayEditAttachment } from './AttachmentsEditModal';

import './style.scss';

export interface IAttachmentDescriptionProps {
  attachment: IDisplayEditAttachment;
  trackLabel?: string;
  onChange?: (e: React.SyntheticEvent<any>, index: number) => void;
  mode: TEditAttachmentModes;
  track?: () => void;
  index: number;
}

const AttachmentDescription: React.FunctionComponent<IAttachmentDescriptionProps> = ({
  trackLabel,
  onChange,
  mode,
  attachment,
  track,
  index,
}) => {
  if (mode === TEditAttachmentModes.READ_ONLY) {
    return (
      <>
        <div className={classnames('field-section')}>
          <label className={classnames('field__label-label')}>Name</label>
          <label className={classnames('field__label-data-field')}>{attachment.title || 'N/A'}</label>
        </div>
        <div className={classnames('field-section')}>
          <label className={classnames('field__label-label')}>Description</label>
          <label className={classnames('field__label-data-field')}>{attachment.description || 'N/A'}</label>
        </div>
      </>
    );
  } else {
    return (
      <>
        <Input
          field={{
            label: 'Name',
            value: attachment.title,
            isRequired: true,
            type: CustomFieldType.TEXT,
          }}
          placeholder="Attachment name here"
          name="title"
          onFocus={trackLabel ? track : undefined}
          onChange={(e) => onChange(e, index)}
          error={attachment.error.title}
          width={12}
        />
        <Input
          field={{
            label: 'Description',
            value: attachment.description,
            isRequired: false,
            type: CustomFieldType.TEXT,
          }}
          placeholder="Attachment description here"
          name="description"
          onFocus={trackLabel ? track : undefined}
          onChange={(e) => onChange(e, index)}
          error={attachment.error.description}
          width={12}
        />
        <Input
          field={{
            label: 'Created On',
            value: attachment.exif && attachment.exif.createdAt,
            isRequired: false,
            type: CustomFieldType.DATE,
          }}
          datePickerOptions={{
            dateFormat: 'MM/DD/YY',
            timeFormat: 'hh:mm:ss A',
          }}
          placeholder="MM/DD/YY hh:mm:ss A"
          name="createdAt"
          onFocus={trackLabel ? track : undefined}
          onChange={(e) => onChange(e, index)}
          width={6}
        />
        <Input
          field={{
            label: 'Location',
            value: attachment.exif && attachment.exif.location,
            isRequired: false,
            type: CustomFieldType.TEXT,
          }}
          placeholder="Attachment location here"
          name="location"
          onFocus={trackLabel ? track : undefined}
          onChange={(e) => onChange(e, index)}
          width={6}
        />
      </>
    );
  }
};

export default AttachmentDescription;
